import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=11987f11"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"
import style0 from "./ProductReviews.vue?vue&type=style&index=0&id=11987f11&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports